export default __webpack_public_path__ + "static/media/arrow-up.d66c4b34.svg";